import { PERMISSIONS, ROUTE_PATHS } from "./../PermissionsConstants";
import { ScoreCard } from "../CarrierAgreementMgmt/ScoreCard";
import Employees from "../CarrierAgreementMgmt/Employees/Confie";
import { UsersIcon, TicketIcon, MapIcon } from "@heroicons/react/24/solid";
import Hierarchy from "modules/CarrierAgreementMgmt/Hierarchy";

export const EmployeeTabs = [
  {
    to: ROUTE_PATHS.EmployeeTab_employee_index,
    component: Employees,
    label: "Employee",
    icon: <UsersIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_employee_main_view,
    title: "Confie",
  },
  {
    to: "/employeetab/hierarchy",
    path: "/employeetab/hierarchy",
    icon: <MapIcon className="h-4 w-4 mr-2 " />,
    label: "SPLC Hierarchy",
    component: Hierarchy,
    permission: PERMISSIONS.permission_hierarchy_view,
  },
  {
    to: "/employeetab/scorecard",
    component: ScoreCard,
    label: "Scorecard",
    icon: <TicketIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_scorecard_view,
  },
];
